import React, { useEffect, useState } from 'react';
import styles from '../addCategoryForm/addCategoryForm.module.css';
import { Add, Close, Delete, UploadImg } from '../../Svg';
import api from '../../utils/api';
import { useParams } from 'react-router-dom';

const ViewAtributeForm = () => {

    const [loading, setLoading] = useState(false)
    const [atributes, setAtributes] = useState(null)

    const { id } = useParams()

    const fetchAtributes = async () => {
        setLoading(true)
        try {
            const { data, status } = await api.viewAtribute(id)
            console.log(data?.data);

            if (status == 200) {
                setAtributes(data?.data);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        if (id) {
            fetchAtributes()
        }
    }, [id])


    return (
        <>
            <div className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Variation</h2>
                            <label className={styles.addCatLabel}>
                                Variant Type/name

                                <div className={styles.addCatInput}>{atributes?.variant_name}</div>
                            </label>
                            <label className={styles.addCatLabel}>
                                Variation value
                                {atributes?.variation_value?.length > 0 ?

                                    <>
                                        {atributes?.variation_value?.map((atributes) => (


                                            <div className={styles.addCatInput}>
                                                {atributes}
                                            </div>
                                        ))
                                        }
                                    </>

                                    :
                                    <div>
                                        No Variation value
                                    </div>
                                }

                            </label>
                        </div>
                    </div>

                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card} >
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label className={styles.addCatLabel}>
                            Category Status*

                            <div className={styles.addCatSelect}>
                                {atributes?.status}
                            </div>
                        </label>
                    </div>
                </div>

            </div>
        </>
    );
};

export default ViewAtributeForm;
